import { render, staticRenderFns } from "./AttachGpu.vue?vue&type=template&id=76978254&scoped=true"
import script from "./AttachGpu.vue?vue&type=script&lang=js"
export * from "./AttachGpu.vue?vue&type=script&lang=js"
import style0 from "./AttachGpu.vue?vue&type=style&index=0&id=76978254&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76978254",
  null
  
)

export default component.exports